/**
 * @generated SignedSource<<949260d5c20305e5f321e01b8efdf807>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type SurveyStatus = "AVAILABLE" | "FAIL" | "PENDING" | "SUCCESS";
import { FragmentRefs } from "relay-runtime";
export type SurveyCard_survey$data = {
  readonly adminData: {
    readonly rankScore: number;
    readonly surveyGuid: string;
  } | null;
  readonly durationDetails: {
    readonly providerDuration: number;
  };
  readonly iconUrl: string;
  readonly id: string;
  readonly lockedInfo: {
    readonly title: string | null;
  } | null;
  readonly rewardAmount: {
    readonly subUnitAmount: number;
  } | null;
  readonly status: SurveyStatus;
  readonly supportId: string | null;
  readonly tags: ReadonlyArray<string>;
  readonly title: string;
  readonly url: string | null;
  readonly " $fragmentType": "SurveyCard_survey";
};
export type SurveyCard_survey$key = {
  readonly " $data"?: SurveyCard_survey$data;
  readonly " $fragmentSpreads": FragmentRefs<"SurveyCard_survey">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SurveyCard_survey",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "iconUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CurrencyAmount",
      "kind": "LinkedField",
      "name": "rewardAmount",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "subUnitAmount",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LockedSurveyInfo",
      "kind": "LinkedField",
      "name": "lockedInfo",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supportId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DurationDetails",
      "kind": "LinkedField",
      "name": "durationDetails",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "providerDuration",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tags",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AdminSurveyData",
      "kind": "LinkedField",
      "name": "adminData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rankScore",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "surveyGuid",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Survey",
  "abstractKey": null
};
})();

(node as any).hash = "3ba88fcfa91267fa1fe6abc47d6bd758";

export default node;
